import { Button, Checkbox, Divider, Form, message } from "antd";
import { apiGet, apiPost } from "app/services/apiServices";
import TextField from "app/shared/TextField";
import Typography from "app/shared/Typography";
import { useEffect, useState } from "react";
import AppLogo from "static/images/Logo.svg";
import {
 API_ENDPOINT_AUTH_SIGNIN,
 API_ENDPOINT_AUTH_SIGNIN_OTP,
 API_ENDPOINT_GET_GST_STATUS,
 API_ENDPOINT_GET_USER_INFO,
 API_ENDPOINT_GET_WORKSPACE_REPORTS,
} from "../../auth.constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { emailInfo, userInfo, workspaceReports } from "app/config/States/users";
import { colorPicker } from "app/utils/color.helper";
import { getSubdomain } from "app/utils/generic.helper";
import { Mixpanel } from "app/config/Mixpanel";
import posthog from 'posthog-js';


type FieldType = {
 email?: string;
 password?: string;
};


export default function Login(props: any) {
 const [email, setEmail] = useState("");
 const [password, setPassword] = useState("");
 const [isLoading, setLoading] = useState(false);
 const [messageApi, contextHolder] = message.useMessage();
 const [userDetails, setUserDetails] = useRecoilState(userInfo);
 const [basicAuth, setBasicAuth] = useState(false);
 const [useremail, setUseremail] = useRecoilState(emailInfo);
 const [reports, setWorkspaceReports] = useRecoilState(workspaceReports);


 function useQuery() {
   return new URLSearchParams(useLocation().search);
 }
 const query = useQuery();


 const navigate = useNavigate();


 const handleRedirectBackIfAuthenticate = () => {
   const domain = getSubdomain();
   const token = localStorage.getItem("token");
   if (token) {
     if (domain === "integration") {
       navigate("/credential/gst/landing");
     } else if (domain === "bhilosa" || domain === "followup-stage") {
       fetchUserInfo();
     } else {
       navigate("/dashboard");
     }
   }
 };




 useEffect(() => {
   handleRedirectBackIfAuthenticate();
   Mixpanel.track("User Landed On Login Page");


   const queryEmail = query.get("email") || ""; //
   const parsedEmail = queryEmail.replace(" ", "+");


   const queryPassword = query.get("password") || ""; //


   setEmail(parsedEmail);
   setPassword(queryPassword);
   if (parsedEmail && queryPassword)
     handleLoginNew(parsedEmail, queryPassword);
 }, []);


const handleLoginNew = async (newEmail: string, newPassword: string) => {
  // Check if domain is fcm and email is not finkraft.ai or kgrp.in, then redirect to portal-down
  const domain = getSubdomain();
  if (newEmail) {
    const userEmail = newEmail.toLowerCase();
    const emailDomain = userEmail.split("@")[1];
    const allowedDomains = ["finkraft.ai", "kgrp.in"];
    
    if (domain === "fcm" && emailDomain && !allowedDomains.includes(emailDomain)) {
      navigate("/portal-down");
      return;
    }
  }

  setLoading(true);


  let payload = {
    email: newEmail,
    password: newPassword,
  };
  const response = await apiPost(API_ENDPOINT_AUTH_SIGNIN, payload);
   if (response.status) {
     localStorage.setItem("token", response.data.token);
     localStorage.setItem(email, newEmail);
     fetchUserInfo();
   } else {


     messageApi.error({
       type: "error",
       content: response.message,
     });
   }
   setTimeout(() => {
     setLoading(false);
   }, 1000);
 };


 const fetchWorkspaceGstinStatus = async () => {
   try {
     const response = await apiGet(API_ENDPOINT_GET_GST_STATUS);
     if (response.status) {
       return response.data; // Only return the data property
     } else {
       return []; // Return an empty array as a fallback
     }
   } catch (error) {
     return []; // Return an empty array in case of error
   }
 };


 const fetchReportsAndDashboards = async () => {
   const response = await apiGet(API_ENDPOINT_GET_WORKSPACE_REPORTS);
   if (response.status) {
     setWorkspaceReports(response.data);
   }
 };


 const fetchUserInfo = async () => {
   const domain = getSubdomain();
   const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
   if (response.status) {
     if (response.data?.workspaces.length === 0) {
       localStorage.clear();
       message.error("You do not have any acccess to this portal");
       navigate("/auth/signin");


       return;
     }
     let mmtWorkspace = (response.data.workspaces || []).find(
       (item: any) => item?.meta?.full_access
     );     
     setUserDetails({
       ...response.data,
       currentWorkspace: mmtWorkspace
         ? mmtWorkspace
         : response.data.workspaces[0],
       clusterId: response.data.cluster_id,
     });
     localStorage.setItem(
       "currentWorkspace",
       mmtWorkspace ? mmtWorkspace.id : response.data.workspaces[0]?.id
     );
    localStorage.setItem("email", email);

    Mixpanel.identify(response.data.id);
    Mixpanel.track("Successful login", {
      domain: response?.data?.email?.split("@")[1],
    });
     //@ts-ignore
     localStorage.setItem("session_start_time", new Date().getTime());
     localStorage.setItem(
       "role",
       mmtWorkspace ? mmtWorkspace.role : response.data.workspaces[0]?.role
     );
     localStorage.setItem(
       "name",
       mmtWorkspace ? mmtWorkspace.name : response.data.workspaces[0]?.name
     );


     Mixpanel.people.set({
       $name: response.data.name,
       $email: response.data.email,
       email: response.data.email,
       name: response.data.name,
     });


     const userEmail = response.data.email?.toLowerCase() || "";
     const blockedDomains = ["kgrp.in", "finkraft.ai"];
     const userDomain = userEmail.split("@")[1];
     const isLocalhost =
     window.location.hostname === "localhost" ||
     window.location.hostname === "127.0.0.1";


   if (blockedDomains.includes(userDomain) || isLocalhost) {
     posthog.reset();
   } else {
    
     posthog.identify(response.data.id, {
       email: response.data.email,
       name: response.data.name,
       workspace_name: mmtWorkspace ? mmtWorkspace.name : response.data.workspaces[0]?.name,
       workspace_role: mmtWorkspace ? mmtWorkspace.role : response.data.workspaces[0]?.role,
       domain: domain,
       cluster_id: response.data.cluster_id,
       is_full_access: mmtWorkspace?.meta?.full_access || false,
       initial_login_timestamp: new Date().toISOString()
     });


     posthog.people.set({
       email: response.data.email,
       name: response.data.name,
       workspace: mmtWorkspace ? mmtWorkspace.name : response.data.workspaces[0]?.name,
       last_login: new Date().toISOString()
     });
   }


     const gstinStatus = await fetchWorkspaceGstinStatus();
     if (
       domain === "bhilosa" ||
       domain === "followup" ||
       domain === "followup-stage"
     ) {
       if (gstinStatus?.length > 0) {
         navigate(`/vendorfollowup/gstintegration`, {
           state: {
             GstinStatus: true,
             workspace: response.data.workspaces[0]?.name,
           },
         });
       } else {
         navigate(`/vendorfollowup/gstintegration`, {
           state: {
             GstinStatus: false,
             workspace: response.data.workspaces[0]?.name,
           },
         });
       }
     } else if (domain === "integration") {
       navigate("/credential/gst/landing");
     } else {
       navigate("/dashboard");
     }
     // if (gstinStatus?.length > 0) {
     //   navigate(`/vendorfollowup/gstintegration`, {
     //     state: {
     //       GstinStatus: true,
     //       workspace: response.data.workspaces[0]?.name,
     //     },
     //   });
     // } else {
     //   navigate(`/vendorfollowup/gstintegration`, {
     //     state: {
     //       GstinStatus: false,
     //       workspace: response.data.workspaces[0]?.name,
     //     },
     //   });
     // }


     messageApi.success({
       type: "success",
       content: response.message,
     });


     // if (props.noRouting) {
     //   props.onSuccess && props.onSuccess();
     // } else {
     //   if (response.data.hasOnboared) {
     //     navigate("/dashboard");
     //   } else {
     //     navigate("/dashboard");
     //   }
     // }
   }


  
 };


const handleLogin = async () => {
  // Check if domain is fcm and email is not finkraft.ai or kgrp.in, then redirect to portal-down
  const domain = getSubdomain();
  if (email) {
    const userEmail = email.toLowerCase();
    const emailDomain = userEmail.split("@")[1];
    const allowedDomains = ["finkraft.ai", "kgrp.in"];
    
    if (domain === "fcm" && emailDomain && !allowedDomains.includes(emailDomain)) {
      navigate("/portal-down");
      return;
    }
  }

  setLoading(true);
  let payload = {
    email: email,
    password: password,
  };
  const response = await apiPost(API_ENDPOINT_AUTH_SIGNIN, payload);
   if (response.status) {
     localStorage.setItem("token", response.data.token);
     fetchUserInfo();
     fetchReportsAndDashboards();
   } else {
     Mixpanel.track("Unsuccessful login", {
       email: email,
       login_time: new Date().toISOString(), // Example: Timestamp of the event
       error_reason: response.message, // Example: Reason for the failed login
     });
     messageApi.error({
       type: "error",
       content: response.message,
     });
   }
   setTimeout(() => {
     setLoading(false);
   }, 1000);
 };


const handleLoginWithOTP = async () => {
  // Check if domain is fcm and email is not finkraft.ai or kgrp.in, then redirect to portal-down
  const domain = getSubdomain();
  if (email) {
    const userEmail = email.toLowerCase();
    const emailDomain = userEmail.split("@")[1];
    const allowedDomains = ["finkraft.ai", "kgrp.in"];
    
    if (domain === "fcm" && emailDomain && !allowedDomains.includes(emailDomain)) {
      navigate("/portal-down");
      return;
    }
  }

  setLoading(true);
  let payload = {
    email: email,
  };
  const response = await apiPost(API_ENDPOINT_AUTH_SIGNIN_OTP, payload);
   if (response.status) {
     if (props.noRouting) {
       props.onOTPSend && props.onOTPSend({ email: email });
     } else {
       navigate("/auth/signin_otp", { state: { email: email } });
     }
   } else {
     messageApi.error({
       type: "error",
       content: response.message,
     });
   }
   setLoading(false);
 };


 const handleInitPasswordLogin = () => {
   setBasicAuth(true);
 };


 return (
   <div className="AuthForm">
     {props.noRouting ? null : (
       <div className="FormHeader">
         <Typography style={{ color: colorPicker("neutral.700") }}>
           Welcome
         </Typography>
         <Typography
           style={{
             fontSize: 40,
             color: colorPicker("neutral.950"),
             marginTop: -6,
           }}
         >
           Sign in
         </Typography>
       </div>
     )}
     <div className="FieldContainer">
       <Form
         name="basic"
         initialValues={{ remember: true }}
         // onFinish={handleLogin}
         autoComplete="off"
         onFinish={basicAuth ? handleLogin : handleInitPasswordLogin}
       >
         <div className="FieldGroup">
           <Form.Item<FieldType>
             name="email"
             rules={[
               {
                 required: true,
                 type: "email",
                 message: "Please enter your email!",
               },
             ]}
           >
             <TextField
               label="Email"
               placeholder="Email"
               labelColor="var(--text-color-gray)"
               onChange={(e: any) => setEmail(e.target.value)}
               value={email}
               defaultValue={email}
             />
           </Form.Item>
         </div>
         {basicAuth ? (
           <div className="FieldGroup" style={{ marginTop: 28 }}>
             <Form.Item<FieldType>
               name="password"
               // rules={[
               //   { required: true, message: "Please enter your password!" },
               // ]}
             >
               <TextField
                 label="Password"
                 placeholder="Password"
                 labelColor="var(--text-color-gray)"
                 onChange={(e: any) => setPassword(e.target.value)}
                 type="password"
               />
             </Form.Item>
           </div>
         ) : null}


         <div className="FieldGroup" style={{ marginTop: 38 }}>
           <Button
             type="primary"
             style={{ width: "100%" }}
             size="large"
             // disabled={!email || !password}
             loading={isLoading}
             htmlType={"submit"}
           >
             {basicAuth ? "Sign in" : "Sign in with password"}
           </Button>
         </div>


         {basicAuth ? null : (
           <>
             <Divider>
               <Typography
                 variant="xs"
                 style={{ color: colorPicker("neutral.800") }}
               >
                 OR
               </Typography>
             </Divider>


             <div className="FieldGroup" style={{ marginTop: 38 }}>
               <Button
                 type="primary"
                 style={{ width: "100%" }}
                 size="large"
                 ghost
                 // disabled={!email || !password}
                 loading={isLoading}
                 htmlType={"submit"}
                 onClick={handleLoginWithOTP}
               >
                 Sign in with OTP
               </Button>
             </div>
             {/* <div
               className="FieldGroup"
               style={{ justifyContent: "flex-end", display: "flex" }}
             >
               <Typography
                 variant="caption"
                 style={{ color: colorPicker("neutral.800") }}
               >
                 New User?{" "}
                 <b
                   style={{
                     cursor: "pointer",
                     color: colorPicker("primary.700"),
                   }}
                   onClick={() => navigate("/auth/signup")}
                 >
                   Register
                 </b>
               </Typography>
             </div> */}
           </>
         )}
       </Form>
     </div>
     {contextHolder}
   </div>
 );
}



